import React, { useState } from 'react'
import styled from 'styled-components'
import { COLOR_GREEN, COLOR_WHITE } from '../../constants/colors';
import axios from 'axios';
import { REMOVE_EMAIL_SUBSCRIPTION_URL } from '../../constants/cloudFunctions';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-top: 10%;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
  h1 {
    color: ${COLOR_GREEN};
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; 
`

const Form = styled.div`
  margin-top: 5%;
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
  }

  input:nth-child(2) {
    margin-bottom: 15%;
    width: 250px;
  }

  input:nth-child(3) {
    width: auto;
    border: none;
    padding: 12px 8px;
    background-color: ${COLOR_GREEN};
    color: ${COLOR_WHITE};
    font-weight: bold;
    border-radius: 10px;
  }

  input:nth-child(3):hover {
    cursor: pointer;
  }
`

const UnsubscribeNewsletter = () => {
  const [ updated, _setUpdated ] = useState<boolean>(false);

  const unsubscribe = async (e: any) => {
    e.preventDefault();

    const email = e.target.email.value;
    axios
      .post(REMOVE_EMAIL_SUBSCRIPTION_URL + `?email=${email}`)
      .then(response =>  {
        _setUpdated(true);
      })
      .catch(err => {
        alert("Désolé, email non reconnu. Veuillez vérifier vos informations")
      })
  }

  return (
    <Wrapper>
      <h1>Désinscription</h1>
      <Content>
        {
          updated ?
          <>
            Votre email a bien été supprimé de nos listes
          </> :
          <>
            Veuillez entrer votre email et cliquer sur "Me désinscrire" pour ne plus recevoir de courriels de notre part.
            <Form>
              <form onSubmit={unsubscribe}>
                <label htmlFor='email'>Email: </label>
                <input type="email" id="email" name="email" required/>
                <input type="submit" value="Me désinscrire" />
              </form>
            </Form>
          </>
        }
      </Content>
    </Wrapper>
  )
}

export default UnsubscribeNewsletter;